import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function MaxWidthContainer({
  isExtended = false,
  className = '',
  children = null
}) {
  return (
    <div data-extended={isExtended} className={cn(styles.container, className)}>
      {children}
    </div>
  );
}
